import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, isUndetermined, makeHistory } from "../../HistoryUtils";
import Value from "./Value";
import YesNoOrChildren from "./YesNoOrChildren";

const AllergiesHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, ["allergiesText"]);
    return (
        <HistoryContainerAndTitle
            title={t(`anamnesis.allergies.title`)}
            isVisible={isVisible || !isUndetermined(history.getLatestValueOf("haveAllergies"))}
        >
            <YesNoOrChildren
                {...{
                    label: t(`anamnesis.allergies.title`),
                    switchValue: history.getLatestValueOf("haveAllergies"),
                    isChildrenVisible: isVisible,
                }}
            >
                <Value>{history.getLatestValueOf("allergiesText")}</Value>
            </YesNoOrChildren>
        </HistoryContainerAndTitle>
    );
};

export default AllergiesHistory;
